/*
 * A scale bar, in numbers. Pure, so the viewer, the workbench and the tests read
 * it the same way. The server computes the scale again from what is sent
 * (routes/microscopy.py _measured_bar): these only say what it will say.
 */
//: routes/microscopy.py MIN_BAR_PX: a shorter line can't carry a scale.
export const MIN_BAR_PX = 10;

/** A line's length in the picture's pixels, or 0 for none. */
export function barLength(line) {
  if (!line || line.length !== 2) return 0;
  return Math.hypot(line[1][0] - line[0][0], line[1][1] - line[0][1]);
}

/** The µm per pixel a bar of `um` micrometres drawn as `line` gives, or null. */
export function scaleFromBar(um, line) {
  const px = barLength(line);
  const length = Number(um);
  if (px < MIN_BAR_PX || !(length > 0)) return null;
  return length / px;
}

/** How far one scale stands from another, as a fraction, or null when either is missing. */
export function scaleChange(next, current) {
  if (!next || !current) return null;
  return Math.abs(next - current) / current;
}

/**
 * A round length (1, 2 or 5 x 10^k µm) close to a fifth of the picture's width:
 * microscopy_meta.scale_bar_um's choice, for a slide whose answer doesn't carry it.
 */
export function roundBarUm(umPerPx, widthPx) {
  if (!umPerPx || !widthPx) return null;
  const target = (umPerPx * widthPx) / 5;
  let best = null;
  for (let k = -2; k <= 6; k += 1) {
    [1, 2, 5].forEach((m) => {
      const length = Number((m * 10 ** k).toPrecision(3));
      if (length <= target * 1.5 && (best === null || Math.abs(length - target) < Math.abs(best - target))) best = length;
    });
  }
  return best;
}

/** The bar an image shows, in its pixels: {um, px}, or null with no scale. */
export function shownBar(image) {
  const scale = Number(image?.um_per_px);
  if (!scale) return null;
  const um = image.scale_bar_um ?? roundBarUm(scale, image.width_px);
  return um ? { um, px: um / scale } : null;
}
